module.exports = __webpack_public_path__ + "fonts/brelaregular.53b8286.eot";